import React from 'react';
import NextImage from 'next/image';
import Academia from 'svg/Academia';
import Location from 'svg/Location';
import Share from 'svg/Share';
import Users from 'svg/Users';
import { ButtonText } from 'components/Button';
import DetailCard from './DetailCard';
import { GroupPageContentProps } from './types';

function GroupPageContent({ shareAction, group, imageUrl }: GroupPageContentProps) {
  const membersDisplayCount = group?.memberDisplayCount || 0;
  const membersAggregateCount = group?.membersAggregate?.aggregate?.count || 0;

  const membersCount =
    membersDisplayCount > membersAggregateCount ? membersDisplayCount : membersAggregateCount;

  let rankSize = 5;

  if (membersCount < 10) {
    rankSize = 12;
  } else if (membersCount < 20) {
    rankSize = 9;
  } else if (membersCount < 50) {
    rankSize = 7;
  } else if (membersCount < 100) {
    rankSize = 4;
  } else if (membersCount < 200) {
    rankSize = 2;
  }

  return (
    <div className="flex flex-col gap-3">
      {/* Row 1: Image + Name/Location + Share */}
      <div className="flex items-center gap-5">
        <NextImage
          src={imageUrl}
          alt=""
          height={180}
          width={180}
          loading="lazy"
          className="shrink-0 rounded-lg object-cover object-center xs:h-[11rem] xs:w-[11rem]"
        />
        <div className="flex min-w-0 flex-1 flex-col gap-1">
          <h1 className="typography-product-heading text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
            {group?.title || ''}
          </h1>
          <div className="typography-product-caption flex items-center text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
            <Location className="mr-1 h-4 w-4 shrink-0 text-color-bg-lightmode-icon dark:text-color-bg-darkmode-icon" />
            <span>{group?.city?.name || ''}</span>
          </div>
        </div>
        <ButtonText
          size="sm"
          className="flex shrink-0 cursor-pointer items-center self-start text-color-text-lightmode-primary dark:text-color-text-darkmode-primary"
          onClick={shareAction}
        >
          <Share className="mr-1 h-4 w-4" /> Share
        </ButtonText>
      </div>

      {/* Row 2: Description */}
      <p className="lg:typography-product-body xs:typography-product-element-label text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary ![overflow-wrap:anywhere] break-normal">
        {group?.description || ''}
      </p>

      {/* Row 3: Stats */}
      <div className="grid grid-cols-2 gap-6">
        <DetailCard
          Icon={Users}
          description={membersCount.toString() || '0'}
          title="Total group members"
        />
        <DetailCard Icon={Academia} description={`${rankSize}%`} title="Rank by size" />
      </div>
    </div>
  );
}

export default GroupPageContent;
